import './App.css';
import 'typeface-roboto';
import React, { Component } from 'react';
import { Layout, Row, Col, Badge, Alert } from 'antd';
import { connect } from 'react-redux';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { hot } from 'react-hot-loader/root';

import { queryClient } from './queryClient';
import LoginPage from './containers/Login/container';
import { TabBar } from './components/appbar';
import Calendar from './containers/Calendar/Calendar';
import RequestsContainer from './containers/Requests/requests.container';
import DocumentsContainer from './containers/Documents/DocumentsContainer';
import QuestionsContainer from './containers/Questions/QuestionsContainer';
// import InformationsContainer from './containers/Informations/informations.container';
import NewStatisticContainer from './containers/Statistics/Statistics';
// import StatisticContainer from './containers/OldStatistics/Statistics';
import AdministratorContainer from './containers/administrator.container';
import { requestsActions } from './containers/Requests/requests.actions';
// import HousingStockContainer from "./containers/housing-stock.container";
import HousingStockContainer from './containers/HousingStock/HousingStockContainer';
import { actions as socketioActions } from './actions/socketio.actions';
import { QueryClientProvider } from 'react-query';
import DebtsContainer from './containers/Debts/container';
import VotingPage from './containers/Voting/container';
import MeterContainer from './containers/Meter/container';
import PageNotFound from './containers/PageNotFound/container';
import Profile from './containers/Profile/container';
import AccountMenuHeader from './components/AccountMenuHeader/AccountMenuHeader';
import OfficesMain from './containers/Offices/OfficesMain/OfficesMain';
import Phone from './containers/Phone/Phone';
import {
  statisticsPages,
  statisticsPagesReg,
} from './constants/statisticsPages';
import SipPhoneProvider from './components/SipPhoneProvider';
import { getPhoneSettings } from './queries/usePhoneSettings';
import CallHistory from './containers/CallHistory/CallHistory';
import { setUserMediaError } from './containers/Phone/store/actions';
import Informations from './containers/NewInformations/Informations';
import { Administration } from './containers/Administration/Administration.container';
import {
  adminPaths,
  adminPathsRootWithoutFirstSlash,
} from './containers/Administration/constants/paths';
import Shutdowns from './containers/Shutdowns/Shutdowns';
import RoomsAcceptance from './containers/RoomsAcceptance';
import TransportPermits from './containers/TransportPermits';

const { Header, Content, Footer } = Layout;

const headTitle = {
  Requests: 'Заявки',
  Documents: 'Документы',
  Offices: 'Офисы',
  Calendar: 'Календарь',
  // Statistics: 'Статистика',
  NewStatistics: 'Статистика',
  Questions: 'Вопросы',
  Informations: 'Информирование',
  Voting: 'Опрос',
  Debts: 'Дебиторская задолженность',
  HousingStock: 'Жилой фонд',
  TransportPermits: 'Транспортные средства и пропуска',
  AdministratorRegisteredPhones: 'Подключенные телефоны',
  Meters: 'Общедомовые приборы учёта',
  Profile: 'Профиль',
  CallHistory: 'История звонков',
  [adminPathsRootWithoutFirstSlash]: 'Администрирование',
	Shutdowns: 'Отключения',
  Acceptance: 'Приемки',
};

const appPagePaths = {
  AllowRequests: '/Requests',
  AllowQuestions: '/Questions',
  AllowInformation: '/Informations',
  AllowDocs: '/Documents',
  AllowCalendar: '/Calendar',
  AllowVoting: '/Voting',
  AllowDebts: '/Debts',
  AllowHousingStock: '/HousingStock',
  AllowTransportPermits: '/TransportPermits',
  AllowMeters: '/Meters',
  AllowOffice: '/Offices/:officesTab?',
  // AllowOldStatitics: `/${statisticsPages.root}/${statisticsPagesReg}`,
  AllowStatistics: `/${statisticsPages.newRoot}/${statisticsPagesReg}`,
  AllowAcceptance: '/Acceptance',
  EnableAdminPage: '/AdministratorRegisteredPhones',
};

class App extends Component {
  constructor(props) {
    super(props);

    const { user } = props;
    if (user) props.dispatch(socketioActions.connect({ user }));

    navigator.serviceWorker.addEventListener(
      'message',
      function handler(event) {
        const data = event.data;
        if (!(data && data.mode == 'REQUEST')) return;
        const { requestId } = data;
        if (requestId) {
          props.dispatch(requestsActions.notificationRequest(requestId));
        }
      }
    );

    this.state = {
      host: undefined,
      port: undefined,
      user: undefined,
      password: undefined,
      callPrefix: undefined,
    };
  }

  setPhoneSettings() {
    getPhoneSettings().then((res) => {
      this.setState({
        host: res?.atsIp,
        port: res?.port,
        user: res?.account,
        password: res?.secret,
        callPrefix: res?.defaultPrefix,
      });
    });
  }

  handleUserMediaErrorAlertClose = () => {
    this.props.dispatch(setUserMediaError(null));
  };

  componentDidMount() {
    if (this.props.loggedIn && this.props.user?.access) {
      this.setPhoneSettings();
    }
  }

  componentDidUpdate(prevProps) {
    const { loggedIn: prevLoggedIn, user: prevUser, serviceCompanyPhone: prevServiceCompanyPhone } = prevProps;
    const { loggedIn, user, serviceCompanyPhone } = this.props;

    const prevAccess = prevUser?.access;
    const access = user?.access;

    const isLoggedIn = !prevLoggedIn && loggedIn;
    const accessJustAppeared = !prevAccess && access;

    if ((isLoggedIn || accessJustAppeared) && access && !this.state.user) {
      this.setPhoneSettings();
    }

    if (prevLoggedIn && !loggedIn) {
      this.setState({
        host: undefined,
        port: undefined,
        user: undefined,
        password: undefined,
        callPrefix: undefined,
      });
    }

    if (prevServiceCompanyPhone?.id !== serviceCompanyPhone?.id) {
      this.setState({
        callPrefix: serviceCompanyPhone?.prefix || undefined,
      });
    }
  }

  render() {
    const { loggedIn, userInfo, appPage, connected, userMediaError } =
      this.props;

    let redirectTo;

    if (userInfo) {
      if (userInfo.AllowRequests) {
        redirectTo = appPagePaths.AllowRequests;
      } else {
        const firstAllowPage = Object.keys(userInfo).find(
          (key) =>
            (key.startsWith('Allow') || key.startsWith('Enable')) &&
            userInfo[key]
        );

        if (firstAllowPage) {
          redirectTo = appPagePaths[firstAllowPage];
        }
      }
    }

    const logoHeight = loggedIn ? '28px' : '60px';
    const logoFloat = loggedIn ? 'left' : 'unset';
    const headStyle = loggedIn
      ? {
          width: '100%',
          textAlign: 'left',
          height: '54px',
          padding: '12px 30px 0px 30px',
        }
      : {
          width: '100%',
          textAlign: 'center',
          height: '80px',
          padding: '8px 50px 0px 0px',
        };

    return loggedIn ? (
      <Router>
        {loggedIn ? (
          <SipPhoneProvider
            host={this.state.host}
            port={this.state.port}
            user={this.state.user}
            password={this.state.password}
            callPrefix={this.state.callPrefix}
          >
            <Layout className="layout">
              {loggedIn && this.state.user && (
                <QueryClientProvider client={queryClient}>
                  <Phone />
                </QueryClientProvider>
              )}

              <Header
                className="dspx-header"
                style={headStyle}
              >
                <div
                  className="dispex-logo"
                  style={{ float: logoFloat, lineHeight: 0 }}
                >
                  <img
                    alt=""
                    style={{ height: logoHeight, marginBottom: 6 }}
                    src="/img/logo_full.png"
                  />
                  {loggedIn && (
                    <span
                      style={{ position: 'relative', top: 0, fontSize: 25 }}
                    >
                      <span style={{ color: '#d0e8ff' }}> //</span>{' '}
                      {headTitle[appPage]}
                    </span>
                  )}
                </div>

                {loggedIn && (
                  <QueryClientProvider client={queryClient}>
                    <AccountMenuHeader />
                  </QueryClientProvider>
                )}
              </Header>
              <Content style={{ padding: '0px 0px 0px 0px' }}>
                <div className="dispex-content">
                  {loggedIn && userInfo && (
                    <TabBar allowCallHistory={Boolean(this.state.user)} />
                  )}
                  {loggedIn && userInfo && userMediaError && (
                    <Alert
                      type="warning"
                      message={userMediaError.name}
                      description={userMediaError.description}
                      onClose={this.handleUserMediaErrorAlertClose}
                      closable
                    />
                  )}
                  <Switch>
                    {loggedIn && userInfo && (
                      <Route
                        exact
                        path="/"
                      >
                        <Redirect to={redirectTo} />
                      </Route>
                    )}
                    {loggedIn && userInfo && (
                      <Route
                        exact
                        path="/Profile"
                      >
                        <Profile />
                      </Route>
                    )}
                    {loggedIn && userInfo.EnableAdminPage && (
                      <Redirect
                        from="/Administrator"
                        to={appPagePaths.EnableAdminPage}
                      />
                    )}
                    {loggedIn && userInfo.AllowRequests && (
                      <Route path={`${appPagePaths.AllowRequests}/:id?`}>
                        <QueryClientProvider client={queryClient}>
                          <RequestsContainer />
                        </QueryClientProvider>
                      </Route>
                    )}
                    {loggedIn && userInfo.AllowQuestions && (
                      <Route path={appPagePaths.AllowQuestions}>
                        <QueryClientProvider client={queryClient}>
                          <QuestionsContainer />
                        </QueryClientProvider>
                      </Route>
                    )}
                    {loggedIn && userInfo.AllowInformation && (
                      // <Route path={appPagePaths.AllowInformation} key={1}>
                      //   <InformationsContainer />
                      // </Route>
                      <Route path={appPagePaths.AllowInformation}>
                        <QueryClientProvider client={queryClient}>
                          <Informations />
                        </QueryClientProvider>
                      </Route>
                    )}
                    {loggedIn && userInfo.AllowDocs && (
                      <Route path={appPagePaths.AllowDocs}>
                        <QueryClientProvider client={queryClient}>
                          <DocumentsContainer />
                        </QueryClientProvider>
                      </Route>
                    )}
                    {loggedIn && userInfo.AllowCalendar && (
                      <Route path={appPagePaths.AllowCalendar}>
                        <QueryClientProvider client={queryClient}>
                          <Calendar />
                        </QueryClientProvider>
                      </Route>
                    )}
                    {loggedIn && userInfo.AllowVoting && (
                      <Route path={appPagePaths.AllowVoting}>
                        <VotingPage />
                      </Route>
                    )}
                    {loggedIn && userInfo.AllowDebts && (
                      <Route path={appPagePaths.AllowDebts}>
                        <QueryClientProvider client={queryClient}>
                          <DebtsContainer />
                        </QueryClientProvider>
                      </Route>
                    )}
                    {loggedIn && userInfo.AllowHousingStock && (
                      <Route path={appPagePaths.AllowHousingStock}>
                        {/* <HousingStockContainer /> */}
                        <QueryClientProvider client={queryClient}>
                          <HousingStockContainer />
                        </QueryClientProvider>
                      </Route>
                    )}
                    {loggedIn && userInfo.AllowTransportsAndPermits && (
                      <Route path={appPagePaths.AllowTransportPermits}>
                        <QueryClientProvider client={queryClient}>
                          <TransportPermits />
                        </QueryClientProvider>
                      </Route>
                    )}
                    {loggedIn && userInfo.EnableAdminPage && (
                      <Route path={appPagePaths.EnableAdminPage}>
                        <AdministratorContainer />
                      </Route>
                    )}
                    {loggedIn && userInfo.EnableAdminPage && (
                      <Route path={adminPaths.root}>
                        <QueryClientProvider client={queryClient}>
                          <Administration />
                        </QueryClientProvider>
                      </Route>
                    )}
                    {loggedIn && userInfo.AllowMeters && (
                      <Route path={appPagePaths.AllowMeters}>
                        <QueryClientProvider client={queryClient}>
                          <MeterContainer />
                        </QueryClientProvider>
                      </Route>
                    )}
                    {loggedIn && userInfo.AllowOffice && (
                      <Route path={appPagePaths.AllowOffice}>
                        <QueryClientProvider client={queryClient}>
                          <OfficesMain />
                        </QueryClientProvider>
                      </Route>
                    )}
                    {loggedIn &&
                      userInfo.AllowStatistics && [
                        // <Route path={appPagePaths.AllowOldStatitics} key={1}>
                        //   <QueryClientProvider client={queryClient}>
                        //     <StatisticContainer />
                        //   </QueryClientProvider>
                        // </Route>,
                        <Route
                          path={appPagePaths.AllowStatistics}
                          key={2}
                        >
                          <QueryClientProvider client={queryClient}>
                            <NewStatisticContainer />
                          </QueryClientProvider>
                        </Route>,
                      ]}
                    {loggedIn && this.state.user && (
                      <Route path="/CallHistory">
                        <QueryClientProvider client={queryClient}>
                          <CallHistory />
                        </QueryClientProvider>
                      </Route>
                    )}
                    {loggedIn && userInfo.AllowAlerts && (
                      <Route path="/Shutdowns">
                        <QueryClientProvider client={queryClient}>
                          <Shutdowns />
                        </QueryClientProvider>
                      </Route>
                    )}
                    {loggedIn && userInfo.AllowAcceptance && (
                      <Route path="/Acceptance">
                        <QueryClientProvider client={queryClient}>
                          <RoomsAcceptance />
                        </QueryClientProvider>
                      </Route>
                    )}
                    {loggedIn && (
                      <Route path="*">
                        <PageNotFound />
                      </Route>
                    )}
                  </Switch>
                </div>
              </Content>
              <Footer className="footer-dspx">
                <Row>
                  <Col span={8}>
                    {false && (
                      <Badge status={connected ? 'success' : 'error'} />
                    )}
                  </Col>
                  <Col
                    span={8}
                    style={{ textAlign: 'center' }}
                  >
                    <span>© 2026 Dispex. Все права защищены</span>
                  </Col>
                  <Col span={8} style={{ textAlign: 'right' }}>
                    <span>v1.81.11</span>
                  </Col>
                </Row>
              </Footer>
            </Layout>
          </SipPhoneProvider>
        ) : (
          <LoginPage />
        )}
      </Router>
    ) : (
      <LoginPage />
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  const { loggedIn, userInfo, user } = state.authentication;
  const { appPage } = state.appBarStore;
  const { connected } = state.socketioStore;
  const userMediaError = state.phoneStore.userMediaError;
  const serviceCompanyPhone = state.phoneStore.serviceCompany
  //const { notificationPopup, popupRequest } = state.notificationStore

  return {
    alert,
    loggedIn,
    userInfo,
    user,
    appPage,
    connected,
    userMediaError,
    serviceCompanyPhone,
  };
}

const connectedApp = connect(mapStateToProps)(App);
const app =
  process.env.NODE_ENV === 'development' ? hot(connectedApp) : connectedApp;

export { app as App };
